import ky from 'ky';
import { httpError } from '../utils/errors';
import moment from 'moment';

/**
 * MetricService provides metric API services
 */
class MetricService {

    getPaymentsLast30Days = (id) => {
        //console.log('MetricService.get() id=', id)
        return new Promise((resolve, reject) => {
            // Get the metric data, transforming any errors into a standardised error object
            const ets = moment().valueOf();
            const sts = moment().subtract(30,'days').valueOf();
            const url = `/api/v2/accounts/${id}/metrics/payment-total?sts=${sts}&ets=${ets}`
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    getChargesLast30Days = (id) => {
        //console.log('MetricService.get() id=', id)
        return new Promise((resolve, reject) => {
            // Get the metric data, transforming any errors into a standardised error object
            const ets = moment().unix();
            const sts = moment().subtract(30,'days').unix();

            //console.log('getChargesLast30days ets=', ets, 'sts=',sts, 'moment().valueOf=',moment().valueOf() )

            const url = `/api/v2/accounts/${id}/metrics/charge-total?sts=${sts}&ets=${ets}`
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }
}

// Create a singleton instance of the service to export
const instance = new MetricService();

export default instance;